var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('div',{staticClass:"rating"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }